import { sha256 } from 'js-sha256';

/**
 * Derives a 24-byte deterministic nonce from a public key.
 * 
 * Used in libsodium-compatible encryption (e.g., NaCl box).
 *
 * @param publicKey - Uint8Array (typically 32 bytes)
 * @returns Uint8Array - 24-byte nonce
 */
export function deriveNonce(publicKey: Uint8Array): Uint8Array {
  if (!(publicKey instanceof Uint8Array)) {
    throw new Error('Expected publicKey to be a Uint8Array');
  }

  const hash = sha256.array(publicKey); // 32-byte hash
  return new Uint8Array(hash.slice(0, 24)); // truncate to 24 bytes
}